import config from "../../config";
const AppName = "Free Online Tool";
// const facebookId = '2161902733988351';
const productionurl = config.productionurl;
const imageLink = "free-online-tool.png";
const headValues = {
  title: (inner) => {
    return {
      inner: inner,
      separator: "-",
      complement: AppName,
    };
  },

  meta: (pageName, discriptuion, kewyords, img) => {
    return [
      {
        name: "application-name",
        content: AppName,
      },
      {
        name: "description",
        content: discriptuion,
      },
      {
        name: "keywords",
        content: kewyords + ",Free Online Tool " + AppName,
      },

      { name: "twitter:title", content: pageName },
      // with shorthand
      { n: "twitter:description", c: discriptuion },

      // ...
      // ...
      // Facebook / Open Graph
      // { property: 'fb:app_id', content: facebookId },
      { property: "og:title", content: pageName },
      {
        property: "og:description",
        content: discriptuion,
      },
      {
        property: "og:type",
        content: "website",
      },
      // with shorthand
      { property: "og:image", content: `${productionurl}/${img || imageLink}` },
    ];
  },

  link: (routername) => {
    return [
      {
        rel: "canonical",
        href: `${productionurl}${routername}`,
        id: "canonical",
      },
    ];
  },
};

export default headValues;
